import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FinancialEntityModel,
  InvestmentStrategyModel,
  InvestmentStrategyTypeModel,
  PortfolioModel,
} from '@bp-core/src/lib/proto/common-message.pb';
import { GoalStateEnum } from 'bp/modules/goal/+xstate/goal-new/goal-new-machine.schema';
import { UtilityService } from 'bp/shared/services/utility-service.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';
import { BpImageInfoCardComponent } from '../../../modules/goal/components/bp-image-info-card/bp-image-info-card.component';

@Component({
    selector: 'app-goal-investment-strategy-selector',
    templateUrl: './goal-investment-strategy-selector.component.html',
    styleUrls: ['./goal-investment-strategy-selector.component.scss'],
    standalone: true,
    imports: [
        BpImageInfoCardComponent,
        BpCoreModule,
        MatDividerModule,
        MatButtonModule,
    ],
})
export class GoalInvestmentStrategySelectorComponent implements OnInit {
  title = 'Selecciona una estrategia';
  subtitle: string | undefined;
  StateEnum = GoalStateEnum;
  displayInvestmentStrategies: InvestmentStrategyModel[];
  @Input() portfoliosFilteredForFinancialEntity: PortfolioModel[];
  @Input() gridLayout = false;
  @Input() investmentStrategies: InvestmentStrategyModel[];
  @Input() financialEntity: FinancialEntityModel;
  @Input() investmentStrategyType: InvestmentStrategyTypeModel;
  @Input() isDefault = true;
  @Output() next = new EventEmitter<InvestmentStrategyModel>();

  constructor(private utilityService: UtilityService) {}

  ngOnInit(): void {
    this.utilityService.scrollToTopSmoothly();

    // if (this.financialEntity && this.investmentStrategyType) {
    if (this.financialEntity) {
      this.displayInvestmentStrategies = this.investmentStrategies.filter(
        i =>
          i.investmentStrategyTypeId !== 0 &&
          i.financialEntityId == this.financialEntity.id &&
          i.isDefault === this.isDefault,
      );

      // console.warn(this.displayInvestmentStrategies);
    } else {
      this.displayInvestmentStrategies = this.investmentStrategies;
    }
    this.displayInvestmentStrategies = this.displayInvestmentStrategies.sort((a, b) => {
      return (
        (a.isRecommended ? 0 : 1) - (b.isRecommended ? 0 : 1) || a.displayOrder! - b.displayOrder!
      );
    });
  }
  getPortfoliosFilteredByInvestmentStrategy(investmentStrategy: InvestmentStrategyModel) {
    return this.portfoliosFilteredForFinancialEntity.filter(
      p => p.investmentStrategyId == investmentStrategy.id,
    );
  }
}
